// extracted by mini-css-extract-plugin
module.exports = {"topOrganizationsTableWrapper":"styles_topOrganizationsTableWrapper__noO0L","tableTitle":"styles_tableTitle__2NPmv","tableRowsEmpty":"styles_tableRowsEmpty__2nVc-"};